<template lang="html">
  <div class="edit-prompt">
    <div v-if="editPrompt" class="flex flex-column items-center h-100">
      <div class="roundtable-title-div">
        <div class="mr2">Title:</div>
        <pl-input v-model="roundtable_title" style="flex-grow: 1;"> </pl-input>
      </div>
      <build
        class="rt-create-modal"
        @saveRoundtable="savePayload"
        @isSaving="is_saving = true"
      />
      <div class="flex self-end" style="height: 50px;">
        <pl-button
          @click.native="openEdit"
          class="pl-small"
          style="color: black; font-size: 16px; height: 30px; margin-top: 20px;"
        >
          Close
        </pl-button>
        <pl-button
          @click.native="saveRoundtable(payload_with_changes)"
          class="pl-small pl-primary"
          style="
            color: #f0f0f0;
            font-weight: bold;
            font-size: 16px;
            height: 30px;
            margin-top: 20px;
          "
        >
          Save and Close
        </pl-button>
      </div>
    </div>
  </div>
</template>
<script>
  import Build from 'features/onlineRoundtables/components/editBuild/editBuild.vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default {
    watch: {
      editPrompt() {
        window.renderMath();
      },
    },
    created() {
      this.roundtable_title = this.getCurrentRT.title;
    },
    mounted() {
      window.renderMath();
      this.payload_with_changes.prompt = this.getCurrentRT.prompt;
      EventBus.$on('promptChanged', (changes) => {
        this.payload_with_changes.prompt = changes;
      });
    },
    data() {
      return {
        is_saving: false,
        prompt_changed: false,
        payload_with_changes: { id: '', prompt: ' ', title: '' },
        show_share_to_universe_modal: false,
        is_expanded: false,
        roundtable_title: 'RoundTable',
      };
    },
    props: {
      editPrompt: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Build,
    },
    computed: {
      ...mapGetters([
        'getProfile',
        'getCurrentRT',
        'getCourseDetail',
        'hasTeacherPermissionsInCourse',
        'getOnboarding',
        'getRoundtableAuthor',
        'getSubmissionsBySubmitStatus',
      ]),
      show_save_and_close_button() {
        return (
          !this.is_saving &&
          (this.payload_with_changes || this.changed_rt_title)
        );
      },
      changed_rt_title() {
        return this.getCurrentRT.title !== this.roundtable_title;
      },
      dyanamic_styles() {
        return this.editPrompt
          ? {
              display: 'flex',
              'flex-flow': 'column',
              'align-items': 'flex-end',
            }
          : {};
      },
      submission_cards_exist() {
        return (
          this.getSubmissionsBySubmitStatus.submitted.length ||
          this.getSubmissionsBySubmitStatus.by_passed.length
        );
      },
      prompt_adjusted_with_links() {
        let prompt = this.getCurrentRT.prompt;
        let listItemsString = '';
        if (this.getCurrentRT.links.length > 0) {
          this.getCurrentRT.links.forEach((link) => {
            const linkTag = `<li> <a href="${link.link}"target="_blank"> ${link.title} </a></li>`;
            listItemsString = listItemsString.concat(linkTag);
          });
          prompt = prompt.concat(`<hr /> Links: <ol> ${listItemsString} </ol>`);
        }
        return prompt;
      },
      prompt_text_only() {
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          this.prompt_adjusted_with_links,
          'text/html'
        );
        return doc.documentElement.innerText;
      },
      user_opted_for_not_showing_explanation() {
        return this.getOnboarding.prompt_explanation;
      },
      prompt_card_dynamic_classes() {
        return {
          'edit-mode': this.editPrompt,
          'minimize-prompt': !this.is_expanded,
        };
      },
    },
    methods: {
      saveRoundtable(payload) {
        this.is_saving = true;
        payload.id = this.getCurrentRT.id;
        payload.title = this.roundtable_title;
        if (payload.prompt.trim() === '') {
          payload.prompt = this.getCurrentRT.prompt;
        }
        if (
          this.roundtable_title.length < 4 ||
          this.roundtable_title.length > 99
        ) {
          EventBus.$emit(
            'toast-msg',
            'Provide a Title (between 4 and 99 characters)'
          );
          return;
        }
        this.$store
          .dispatch('savingRTDetails', payload)
          .then(() => {
            this.is_saving = false;
            this.$emit('toggleEditPrompt');
            this.deleteCreateParam();
          })
          .catch((err) => {
            EventBus.$emit(
              'toast-msg',
              'There was an error saving your prompt. Please try again.'
            );
            console.error(err);
            this.is_saving = false;
          });
      },
      savePayload(payload) {
        this.payload_with_changes = payload;
        setTimeout(() => {
          this.prompt_changed = true;
          this.is_saving = false;
        }, 0);
      },
      deleteCreateParam() {
        let query = Object.assign({}, this.$route.query);
        if (query.user_created) {
          delete query.user_created;
          this.$router.replace({ query });
        }
      },
      openEdit() {
        this.$emit('toggleEditPrompt');
        this.roundtable_title = this.getCurrentRT.title;
        this.prompt_changed = false;
        this.is_saving = true;
        this.deleteCreateParam();
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';
  .edit-prompt
    padding: 1em 2em
    border-radius: 5px
    background-color: white
    position: fixed
    width: 680px
    height: 95%
    margin: 0
    left: 50%;
    margin-left: -340px
    margin-top: 1.25%
    top: 0;
    @media only screen and (max-width: 680px)
      width: 100%
      margin-left: 0
      left 0

  .roundtable-title-div
    width: 100%
    margin-bottom: 10px
    text-align: left;
    font-weight: bold
    display:flex
    align-items:center
  .rt-create-modal
    width:100%;
    border-width: unset !important;
    flex-grow : 1
    border: 2px solid #e1e8ee !important
    border-radius: 5px
  .edit-mode
    z-index: 999
    position: fixed
    width: 680px
    height: 95%
    margin: 0
    left: 50%;
    margin-left: -340px
    margin-top: 1.25%
    top: 0;
    @media only screen and (max-width: 680px)
      width: 100%
      margin-left: 0
      left 0
  .minimize-prompt:hover
    border-color: alpha(pl-secondary, 0.7)
    cursor: pointer
</style>
<style lang="stylus">
  #editor_ifr
    height: 100% !important
    overflow: auto !important
    &&::-webkit-scrollbar
      display:none
  .rt-create-modal
    .tox
      .tox-editor-container
        .tox-editor-header
          .tox-toolbar
              width: 85% !important
  .mce-edit-area
    flex-grow:1
  .mce-container-body
    display: flex
    flex-direction: column
  *::webkit-scrollbar
      display:none !important
</style>



// WEBPACK FOOTER //
// promptInFeedModal.vue?c3f0dc2e